import { render, staticRenderFns } from "./changeDutyNew2.vue?vue&type=template&id=034dbc87&scoped=true"
import script from "./changeDutyNew2.vue?vue&type=script&lang=js"
export * from "./changeDutyNew2.vue?vue&type=script&lang=js"
import style0 from "./changeDutyNew2.vue?vue&type=style&index=0&id=034dbc87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034dbc87",
  null
  
)

export default component.exports